import {Button} from '@progress/kendo-react-buttons'
import React from 'react'
import {connect} from 'react-redux'
import {Col, Container, Row} from 'reactstrap'
import {FlashMessage} from '../../components/flash-message'
import * as Link from '../../components/link'
import {Loading} from '../../components/loading'
import * as Menu from '../../components/menu'
import * as RasaInput from '../../components/rasa-input'
import * as Actions from './actions'
import './styles.css'
import * as Types from './types'

interface DispatchProps {
  onSubmit: Types.LoginSubmit,
  updateField: Types.UpdateField,
}

type Props = Types.WrappedState & DispatchProps
export const OAuthLoginPageConnect = ({oauthLogin, onSubmit, updateField}: Props) =>
  <div>
    <Container fluid className="reset">
      <Menu.RasaMenu />
      <FlashMessage />
      <div className="oauth-login">
        <Row>
          <Col><h1>Login</h1></Col>
        </Row>
        <Row>
          <Col>
            <br/>
            <span>Sign in with your email and password.  Password is case sensitive</span>
            <br/>
          </Col>
        </Row>
        <Row>
          <Col>
            <form className="k-form oauth-login-form"
                  onSubmit={Link.preventDefaultThen(() => onSubmit(oauthLogin.fields))}>
              <label className="k-form-field">
                <span>Username</span>
                <RasaInput.RasaInput placeholder="Your Account Email"
                  validation={RasaInput.validateEmail(oauthLogin.fields.username || '')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    updateField({name: 'username', value: e.target.value})}
                  value={oauthLogin.fields.username} />
              </label>
              <label className="k-form-field">
                <span>Password</span>
                <input
                  type="password"
                  className="k-textbox"
                  autoComplete="off"
                  placeholder="Your Account Password"
                  onChange={(e) => updateField({name: 'password', value: e.target.value})}
                />
              </label>
              <label className="k-form-field">
                <span>
                  <Link.AnchorLink href={Menu.AUTH_FORGOT_PASSWORD_URL} className="oauth-login-forgot-password">
                    Forgot your password?
                  </Link.AnchorLink>
                </span>
              </label>
              <label className="k-form-field">
                <span>
                  <Link.AnchorLink href={Menu.AUTH_ONBOARD_URL} className="oauth-login-forgot-password">
                    Did you receive a welcome email with temporary credentials?
                  </Link.AnchorLink>
                </span>
              </label>
              {oauthLogin.ui.isValidating ?
                <Loading size={Loading.Sizes.SMALL} /> :
                <Button
                  primary={true}
                  type="submit"
                  disabled={oauthLogin.fields.username === '' || oauthLogin.fields.password === ''}>
                  Login
                </Button>
              }
            </form>
          </Col>
        </Row>
      </div>
    </Container>
  </div>

export const OAuthLoginPage = connect(
  ({oauthLogin}: Types.WrappedState) => ({
    oauthLogin,
  }),
  {
    onSubmit: Actions.loginSubmit,
    updateField: Actions.updateLoginField,
  },
)(OAuthLoginPageConnect)



// WEBPACK FOOTER //
// ./src/pages/oauth-login/component.tsx